import config from "../config";
import {
  CaptureProfileInfo,
  ELightPath,
  ImagingCaptureProfile,
  ImagingCaptureProfileIdAndName,
} from "../Model/CaptureProfile";
import { EImagingMode } from "../Model/EImagingMode";
import { ImagingSchedule, ScheduleEntry } from "../Model/ImagingSchedule";
import { Module, ModuleCapabilities } from "../Model/Module";
import { ModuleState } from "../Model/ModuleState";
import { ConfigAndPreferenceBackupEntry } from "../Model/Backup";
import {
  sendGetRequest,
  sendPutRequest,
  sendPostRequest,
} from "../Utility/FetchUtils";
import { concatOptionalParameter } from "./../Utility/FetchUtils";
import { ApplicationInfo } from "../Model/ApplicationInfo";
import DateUtil from "../Utility/DateUtil";
import { EInstrumentType } from "../Model/EInstrumentType";

export default class SuiteApi {
  static BASE_URL = config.SERVICE_URL + "/suite";

  static getApplicationInfo() {
    const url = SuiteApi.BASE_URL + "/application-info";
    return sendGetRequest<ApplicationInfo>(url);
  }

  static getInstrumentTypeName() {
    const url = SuiteApi.BASE_URL + "/instrument-type-name";
    return sendGetRequest<string>(url);
  }

  static getImagingMode() {
    const url = SuiteApi.BASE_URL + "/imaging-mode";
    return sendGetRequest<EImagingMode>(url);
  }

  static setImagingMode(imagingMode: EImagingMode) {
    const url = SuiteApi.BASE_URL + `/imaging-mode/${imagingMode}`;
    return sendPutRequest(url);
  }

  static setImagingModeWithDelay(imagingMode: EImagingMode, delay: number) {
    const url = SuiteApi.BASE_URL + `/imaging-mode/${imagingMode}/${delay}`;
    return sendPutRequest(url);
  }

  static getStates(): Promise<ModuleState[]> {
    const url = SuiteApi.BASE_URL + "/states";
    return sendGetRequest<ModuleState[]>(url);
  }

  static getModules(identifier?: string) {
    let url = SuiteApi.BASE_URL + "/modules";
    url = concatOptionalParameter(url, {
      "module-identifier": identifier,
    });
    return sendGetRequest<Module[]>(url);
  }

  static getModuleCapabilities() {
    let url = SuiteApi.BASE_URL + "/capabilities";

    return sendGetRequest<ModuleCapabilities[]>(url);
  }

  static getCaptureProfileIdAndNames(
    id?: string,
    lightpath?: ELightPath,
    imagerIdentifier?: string
  ): Promise<ImagingCaptureProfileIdAndName[]> {
    let url = this.BASE_URL + "/capture-profile-ids";
    url = concatOptionalParameter(url, {
      id: id,
      lightpath: lightpath,
      "imager-identifier": imagerIdentifier,
    });
    return sendGetRequest<ImagingCaptureProfileIdAndName[]>(url);
  }

  static getCaptureProfiles(
    id?: string,
    lightpath?: ELightPath,
    imagerIdentifier?: string
  ): Promise<ImagingCaptureProfile[]> {
    let url = this.BASE_URL + "/capture-profiles";
    url = concatOptionalParameter(url, {
      id: id,
      lightpath: lightpath,
      "imager-identifier": imagerIdentifier,
    });
    return sendGetRequest<ImagingCaptureProfile[]>(url);
  }

  static getCaptureProfileInfos(id?: string): Promise<CaptureProfileInfo[]> {
    let url = this.BASE_URL + "/capture-profile-infos";
    url = concatOptionalParameter(url, {
      id: id,
    });
    return sendGetRequest<CaptureProfileInfo[]>(url);
  }

  //   static getDatabaseStatus() {
  //     const url = this.BASE_URL + "/database-status";
  //     return sendGetRequest(url);
  //   }

  static getQueuedPlates() {
    const url = this.BASE_URL + "/queued-plates";
    return sendGetRequest<ScheduleEntry[]>(url);
  }

  static getScheduledPlates() {
    const url = this.BASE_URL + "/scheduled-plates";
    return sendGetRequest<ScheduleEntry[]>(url);
  }

  static getPlateSchedule(barcode: string): Promise<ImagingSchedule[]> {
    const url = this.BASE_URL + "/schedules/" + encodeURIComponent(barcode);
    return sendGetRequest<ImagingSchedule[]>(url);
  }

  static acceptInitializationMessage() {
    const url = SuiteApi.BASE_URL + `/initializing/:accept`;
    return sendPutRequest(url);
  }

  static getCurrentInstrumentType(): Promise<EInstrumentType> {
    const url = SuiteApi.BASE_URL + "/instrument-type";
    return sendGetRequest<EInstrumentType>(url);
  }
}
